var _g, _defs, _mask, _g2, _g3, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg02BmwSpeedometer5YcEbit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 290 356",
    enableBackground: "new 0 0 290 356",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layout"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "corridor",
    x: 60,
    y: 318,
    opacity: 0.2,
    fill: "#006BB0",
    width: 162,
    height: 9
  }), /*#__PURE__*/React.createElement("line", {
    id: "baseline-2",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    x1: 60,
    y1: 333.5,
    x2: 222,
    y2: 333.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "baseline-1",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    x1: 60,
    y1: 262.5,
    x2: 222,
    y2: 262.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilteriu",
    filterUnits: "userSpaceOnUse",
    x: 60,
    y: 76,
    width: 162,
    height: 251
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 76,
    width: 162,
    height: 251,
    id: "_x35_y_2_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilteriu)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 76,
    width: 22,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 76,
    width: 22,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 76,
    width: 22,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 76,
    width: 22,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 76,
    width: 22,
    height: 251
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_y",
    mask: "url(#_x35_y_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x34_y",
    d: "M66,300h9v27h-9V300z M102,327h9v-28h-9V327z M137,327h9v-21h-9V327z M172,327h9v-15h-9V327z M73,256h9v-13h-9 V256z M108,256h9v-14h-9V256z M143,256h9v-12h-9V256z M178,246v10h9v-10H178z M69,83h-9v173h9V83z M104,84h-9v172h9V84z M139,85h-9 v171h9V85z M174,76h-9v180h9V76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x35_y_1_",
    fill: "#006BB0",
    d: "M207,319h9v8h-9V319z M213,251v5h9v-5H213z M200,256h9V97h-9V256z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "ebit-marge-pin_1_",
    fill: "none",
    stroke: "#006BB0",
    strokeMiterlimit: 10,
    points: "215.5,320 227,294 290,294  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "ergebnis-pin",
    fill: "none",
    stroke: "#006BB0",
    strokeMiterlimit: 10,
    points: "221.5,251.5 227,231 290,231  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "umsatzerloese-pin_1_",
    fill: "none",
    stroke: "#006BB0",
    strokeMiterlimit: 10,
    points: "208.5,97 227,36 290,36  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("text", {
    id: "corridor-min_1_",
    transform: "matrix(1 0 0 1 225 330.2618)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "6px"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    id: "corridor-max",
    transform: "matrix(1 0 0 1 225 318.2618)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "6px"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 203 351.7695)",
    fill: "#006BB0",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "10px"
  }, "2020"), /*#__PURE__*/React.createElement("text", {
    id: "kpi-ebit-marge_1_",
    transform: "matrix(1 0 0 1 270.0269 289.5234)",
    fill: "#006BB0",
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "15px"
  }, "2,7"), /*#__PURE__*/React.createElement("text", {
    id: "head-ebit-marge",
    transform: "matrix(1 0 0 1 19.6182 318.1387)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "EBIT-Marge"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.41,
    y: 8.4,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "in %")), /*#__PURE__*/React.createElement("text", {
    id: "kpi-ergebnis_1_",
    transform: "matrix(1 0 0 1 254.2285 226.5234)",
    fill: "#006BB0",
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "15px"
  }, "2.162"), /*#__PURE__*/React.createElement("text", {
    id: "head-ergebnis",
    transform: "matrix(1 0 0 1 17.9263 238.751)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, " Ergebnis vor"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.13,
    y: 8.4,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "Finanzergebnis"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.45,
    y: 16.8,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "in Mio. \u20AC ")), /*#__PURE__*/React.createElement("text", {
    id: "kpi-umsatzerloese",
    transform: "matrix(1 0 0 1 246.3252 31.5234)",
    fill: "#006BB0",
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "15px"
  }, "80.853"), /*#__PURE__*/React.createElement("text", {
    id: "head-umsatzerloese",
    transform: "matrix(1 0 0 1 14.7202 82.1387)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, " Umsatzerl\xF6se"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.65,
    y: 8.4,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "in Mio. \u20AC ")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg02BmwSpeedometer5YcEbit);
export default __webpack_public_path__ + "static/media/02_BMW_speedometer-5YC-ebit.0c36cfbf.svg";
export { ForwardRef as ReactComponent };